import { render, staticRenderFns } from "./MTalentSearch.vue?vue&type=template&id=da1ac280&"
import script from "./MTalentSearch.vue?vue&type=script&lang=js&"
export * from "./MTalentSearch.vue?vue&type=script&lang=js&"
import style0 from "./MTalentSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports